import React from 'react';
import { cn } from '@/lib/utils';

const STATUS_STYLES = {
  Green: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Amber: 'bg-amber-50 text-amber-700 border-amber-200',
  Red: 'bg-red-50 text-red-700 border-red-200',
  Pending: 'bg-slate-100 text-slate-600 border-slate-200',
  Approved: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Rejected: 'bg-red-50 text-red-700 border-red-200',
  'In Progress': 'bg-blue-50 text-blue-700 border-blue-200',
  'Pending Review': 'bg-amber-50 text-amber-700 border-amber-200',
  'Mitigation Drafted': 'bg-violet-50 text-violet-700 border-violet-200',
  High: 'bg-red-50 text-red-700 border-red-200',
  Medium: 'bg-amber-50 text-amber-700 border-amber-200',
  Low: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Active: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  Inactive: 'bg-slate-100 text-slate-500 border-slate-200',
};

export default function StatusBadge({ status, className, dot = true }) {
  const style = STATUS_STYLES[status] || 'bg-slate-100 text-slate-700 border-slate-200';
  const dotColor = {
    Green: 'bg-emerald-500',
    Amber: 'bg-amber-500',
    Red: 'bg-red-500',
    Pending: 'bg-slate-400',
    Approved: 'bg-emerald-500',
    Rejected: 'bg-red-500',
    'In Progress': 'bg-blue-500',
    'Pending Review': 'bg-amber-500',
    'Mitigation Drafted': 'bg-violet-500',
    High: 'bg-red-500',
    Medium: 'bg-amber-500',
    Low: 'bg-emerald-500',
    Active: 'bg-emerald-500',
    Inactive: 'bg-slate-400',
  }[status] || 'bg-slate-400';

  return (
    <span className={cn('inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-medium', style, className)}>
      {dot && <span className={cn('w-1.5 h-1.5 rounded-full', dotColor)} />}
      {status}
    </span>
  );
}
